<template>
    <v-data-table
            :headers="headers"
            :items="members"
            hide-actions
            class="elevation-1"
    >
        <template slot="headerCell" slot-scope="props">
            <v-tooltip top max-width="400">
                <span slot="activator">
                    <span v-if="props.header.icon && !props.header.subtitle"><img style="display:inline;" :src="`/static/img/icons/${props.header.icon}.png`"></span>
                    <span v-else-if="props.header.icon" class="header-icon-container" :style="`background-image: URL('/static/img/icons/${props.header.icon}.png');`">
                        <center><span class="header-icon-caption">{{props.header.subtitle}}</span></center>
                    </span>
                    <span v-else>
                    {{ props.header.text }}
                    </span>
                </span>
                <span v-html="props.header.tooltip || props.header.text"></span>
            </v-tooltip>
        </template>

        <!--// "guestTiles" : 328,-->
        <!--headers.push({icon: "expansions", text: 'Expansions', value: 'unlockedAreas', sortable: isSortable, tooltip: "The total number of expansions in a players city."});-->
        <!--headers.push({icon: "tiles", text: 'Total Tiles', value: 'cityReport.unlockedTiles',sortable: isSortable, tooltip: "The total number of tiles (equals number of expansions x 25)" })-->
        <!--headers.push({icon: 'money', text: 'Tiles', value: 'cityReport.residentialTiles', sortable: isSortable, tooltip: "Number of tiles used by residences"});-->
        <!--headers.push({icon: 'supplies', text: 'Tiles', value: 'cityReport.productionTiles', sortable: isSortable, tooltip: "Number of tiles used by workshops"});-->
        <!--headers.push({icon: 'goods', text: 'Tiles', value: 'cityReport.goodsTiles', sortable: isSortable, tooltip: "Number of tiles used by goods manufactories" });-->
        <!--headers.push({icon: 'culture' ,text: 'Tiles ', value: 'cityReport.culturalTiles', sortable: isSortable, tooltip: "Number of tiles used by culture / culture/population hybrid buildings" });-->
        <!--headers.push({icon: 'ancient_wonders', text: 'Tiles ', value: 'cityReport.wonderTiles', sortable: isSortable, tooltip: "Number of tiles consumed by streets" });-->
        <!--headers.push({icon: 'streets', text: 'Tiles', value: 'cityReport.streetTiles', sortable: isSortable, tooltip: "Number of tiles consumed by streets" });-->
        <!--headers.push({icon: 'guest', text: 'Tiles', value: 'cityReport.guestTiles', sortable: isSortable, tooltip: "Number of tiles for guest races"} );-->
        <!--headers.push({icon: 'tiles', text: 'Tiles', value: 'cityReport.emptyTiles', sortable: isSortable, tooltip: "Number of empty tiles"} );-->

        <template slot="items" slot-scope="props">
            <td v-if="members && members.length > 1"><elv-avatar-icon :avatar="props.item.avatar" :isFriend="props.item.isFriend"  width="32"/></td>
            <td v-if="members && members.length > 1" ><router-link :to="'/player/'+ props.item.server + '/' + props.item.playerId">{{ props.item.username }}</router-link></td>
            <td>{{props.item.unlockedAreas+5}}</td>
            <!--<td>{{props.item.cityReport.unlockedTiles }}</td>-->
            <td>{{props.item.cityReport.residentialTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.productionTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.goodsTiles| numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.culturalTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.wondersTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.streetTitles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.guestTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
            <td>{{props.item.cityReport.emptyTiles | numPercent(props.item.cityReport.unlockedTiles)}}</td>
        </template>

        <template slot="no-data">
            <v-alert :value="true" color="info" icon="info">
                Sorry, nothing to display here :(
            </v-alert>
        </template>
    </v-data-table>
</template>

<script>
    import VueNumeric from 'vue-numeric';
    import ElvAvatarIcon from "./ElvAvatarIcon"
    export default {
        name: "elv-tiles-table",
        props: { members: {required:true} },
        components: {
            ElvAvatarIcon,
            VueNumeric},
        computed: {
            headers: {
                get: function() {
                    let isSortable = this.members && this.members.length > 1;
                    let headers = [];
                    if( this.members && this.members.length > 1 ) {
                        headers.push({text: "", value: 'avatar', sortable: false});
                        headers.push({text: 'Username', align: 'left', sortable: isSortable, value: 'username'});
                    }
                        //  "unlockedTiles" : 3125,
                        // "emptyTiles" : 127,
                        // "residentialTiles" : 576,
                        // "productionTiles" : 229,
                        // "goodsTiles" : 550,
                        // "wondersTiles" : 201,
                        // "culturalTiles" : 252,
                        // "streetTitles" : 251,
                        // "guestTiles" : 328,
                    headers.push({icon: "expansions", subtitle: this.$i18n.t('site.common.expansions'), value: 'unlockedAreas', sortable: isSortable, tooltip: "The total number of expansions in a players city."});
                    // headers.push({icon: "tiles", subtitle: 'Total Tiles', value: 'cityReport.unlockedTiles',sortable: isSortable, tooltip: "The total number of tiles (equals number of expansions x 25)" })
                    headers.push({icon: 'money', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.residentialTiles', sortable: isSortable, tooltip: "Number of tiles used by residences"});
                    headers.push({icon: 'supplies', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.productionTiles', sortable: isSortable, tooltip: "Number of tiles used by workshops"});
                    headers.push({icon: 'goods', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.goodsTiles', sortable: isSortable, tooltip: "Number of tiles used by goods manufactories" });
                    headers.push({icon: 'culture' ,subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.culturalTiles', sortable: isSortable, tooltip: "Number of tiles used by culture / culture/population hybrid buildings" });
                    headers.push({icon: 'ancient_wonders', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.wondersTiles', sortable: isSortable, tooltip: "Number of tiles consumed by ancient wonders" });
                    headers.push({icon: 'streets', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.streetTitles', sortable: isSortable, tooltip: "Number of tiles consumed by streets" });
                    headers.push({icon: 'guest', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.guestTiles', sortable: isSortable, tooltip: "Number of tiles for guest races"} );
                    headers.push({icon: 'tiles', subtitle: this.$i18n.t('site.fellowship.cityCoverageTable.tiles'), value: 'cityReport.emptyTiles', sortable: isSortable, tooltip: "Number of empty tiles"} );
                    return headers;
                }
            }
        }
    }
</script>

<style scoped>

    .header-icon-caption {
        position:relative;
        top:24px;
        font-size: 95%;
        padding: 0px 2px 0px 2px;
        text-align: center;
        width: 28px;
    }
    .header-icon-container {
        background-repeat: no-repeat;
        background-position-y: top;
        background-position-x: center;
        position:relative;
        top:-4px;
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 5px;
        width:32px;
        min-width:32px;
        height:24px;
        display: inline-block;
    }

    input[type="tel"] {
        margin: 0;
        padding: 0;
        width: 65px;
    }

    th .tooltip {
        position: unset;
        font-family: unset;
        font-size: unset;
        font-style: unset;
        font-weight: unset;
        line-height: unset;
        text-align: unset;
        text-align: left;
        display: unset;
        /* text-decoration:none; */
        /* text-shadow:none; */
        text-transform: uppercase;
        letter-spacing: unset;
        word-break: unset;
        word-spacing: unset;
        word-wrap: unset;
        white-space: unset;
        filter: unset;
        line-break: unset;
        opacity: unset;
        /* line-break:auto; */
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvTilesTable.vue